export default {"src":"/_next/static/media/RIVN.5c9f46dd.svg","height":18,"width":18};